/* eslint-disable */
import _ from 'underscore';

export type ClarityMethod = (method: string, ...args: unknown[]) => void;
export type ClarityQueueMethod = ClarityMethod & { q?: IArguments[] };
export type ClarityBootstrapWindow = Window & typeof globalThis & Record<string, ClarityQueueMethod>;

declare global {
  interface Window {
    clarity?: ClarityMethod;
  }
}

export type ClarityTagValue = string | number | boolean | object;

export type ClarityTags = Record<string, ClarityTagValue>;

export type CookieConsent = {
  ad?: boolean;
  analytics?: boolean;
};

function initialize(projectId: string): void {
  try {
    (function (c: ClarityBootstrapWindow, l: Document, a: string, r: string, i: string, t?: HTMLScriptElement, y?: Node) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r) as HTMLScriptElement; t.async = true; t.src = `https://www.clarity.ms/tag/${i}`;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    }(window as ClarityBootstrapWindow, document, 'clarity', 'script', projectId));
  } catch (all) { }
}

export function setClarityScenario(scenarioName: string): void {
  setClarityTag({ Scenario: scenarioName });
}

export function setClarityTag(tags: ClarityTags): void {
  if (window.clarity) {
    _.each(_.keys(tags), (key: string) => {
      const tagValue = tags[key];
      if (tagValue) {
        window.clarity('set', key, _.isString(tagValue) ? tagValue : JSON.stringify(tagValue));
      }
    });
  }
}

const getConsentValue = (value?: boolean): string => (value ? 'granted' : 'denied');

export const setCookieConsent = (consent: CookieConsent): void => {
  if (!_.isEmpty(consent) && window.clarity) {
    window.clarity('consentv2', {
      ad_Storage: getConsentValue(consent.ad),
      analytics_Storage: getConsentValue(consent.analytics)
    });
  }
}

export function setupClarity(projectId: string, tags: ClarityTags = {}, userId?: string, sessionId?: string, pageId?: string, consent: CookieConsent = {}): void {
  initialize(projectId);

  setClarityTag(tags);

  if (userId || sessionId || pageId) {
    window.clarity('identify', userId, sessionId, pageId);
  }

  setCookieConsent(consent);
}